<template>
  <div>
    <div
      class="text-xs-center pa-2"
      style="border: 1px solid #eee; float: left; border-radius: 10px"
    >
      <template v-if="baseUrl">
        <img
          ref="answer"
          style="width: 100%; max-width: 255px"
          :src="baseUrl.replace('?_ignored=', '')"
        />
      </template>

      <div class="primary--text caption">Tree View</div>
      <v-btn
        color="primary"
        depressed
        @click="
          () => {
            show = true
            onclick()
          }
        "
        >{{ $t('Edit') }}</v-btn
      >

      <v-dialog v-model="show" fullscreen>
        <v-card style="overflow: hidden">
          <v-layout>
            <v-flex>
              <div class="primary--text headline pa-2">Tree View</div>
            </v-flex>
            <v-flex>
              <div class="text-xs-right">
                <v-btn flat fab small @click="show = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <!-- :src="`https://tree-view.zwiz.app/th?url=${locationOrigin}&t=${Date.now()}`" -->
          <!-- :src="`http://localhost:3500/th?url=${locationOrigin}&t=${Date.now()}`" -->
          <iframe
            v-if="show"
            id="iframe-tree-view-edit"
            :key="reRenderKey"
            :src="`https://tree-view.zwiz.app/th?url=${locationOrigin}&t=${Date.now()}`"
            style="
              height: 100%;
              overflow: auto;
              width: 100%;
              border: none;
              position: absolute;
              inset: 60px 0 0;
            "
            sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
            allowfullscreen="true"
          />
        </v-card>
      </v-dialog>
    </div>
    <div class="clearfix"></div>
    <div class="caption mt-2 warning--text">
      {{ $t('note_this_messages_will_be_shown_on_webchat') }}
    </div>
  </div>
</template>

<script>
import jsonFormatter from 'json-string-formatter'

export default {
  components: {},
  props: ['value'],
  data: function () {
    return {
      linkurl: '',
      hasLinkUrl: false,
      show: false,
      message: null,
      baseUrl: null,
      reRenderKey: 0,
      locationOrigin: ''
    }
  },
  watch: {
    value: function (newVal) {
      var vm = this
      vm.baseUrl = newVal.baseUrl
      this.message = jsonFormatter.format(JSON.stringify(newVal))
    },
    show: function () {
      this.reRenderKey++
    }
  },
  mounted: function () {
    var vm = this
    vm.baseUrl = vm.value.baseUrl
    vm.message = jsonFormatter.format(JSON.stringify(vm.value))
    vm.cached_message = jsonFormatter.format(JSON.stringify(vm.value))
    this.locationOrigin = window.location.origin
    this.reRenderKey++
  },
  beforeDestroy() {
    window.removeEventListener(
      'message',
      (e) => {
        if (e.data) {
          this.handleListenEventMessage(e.data)
        }
      },
      false
    )
  },
  methods: {
    handleListenEventMessage({ event_id, data }) {
      switch (event_id) {
        case 'zwiz-tree-view-cancel':
          this.onCancel()
          break
        case 'zwiz-tree-view-ready':
          this.onReady()
          break
        case 'zwiz-tree-view-edit':
          this.message = jsonFormatter.format(JSON.stringify(data))
          this.onSave()
          break
      }
    },
    onclick: function () {
      this.message = this.value
      this.show = true

      window.addEventListener(
        'message',
        (e) => {
          if (e.data) {
            this.handleListenEventMessage(e.data)
          }
        },
        false
      )
    },
    onReady: function () {
      setTimeout(() => {
        if (document.querySelector('iframe#iframe-tree-view-edit')) {
          const iframeTreeViewEdit = document.querySelector('iframe#iframe-tree-view-edit')

          iframeTreeViewEdit.contentWindow.postMessage(
            {
              event_id: 'zwiz-tree-view-edit',
              data: this.message
            },
            '*'
          )
        }
      }, 1000)
    },
    onCancel: function () {
      this.show = false
      this.message = this.cached_message
    },
    onSave: async function () {
      const vm = this
      try {
        const tempMessage = JSON.parse(vm.message)
        const tempBubble = {
          ...tempMessage,
          type: 'tree_view'
        }

        vm.$emit('input', tempBubble)
        vm.message = jsonFormatter.format(vm.message)
        vm.show = false
        vm.cached_message = vm.message
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentTreeView.vue